import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, rem, getResetByTag, utilityStyles } from '../../../../styles';
import StyledModalFooterInner from './styles/modal.footer.inner.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("background-color:", colors.white, ";bottom:0;color:", colors.navy_500, ";flex-shrink:0;padding:", rem(0, 0, 0, 16), ";position:relative;width:100%;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var hasBorderStyles = function hasBorderStyles(_ref) {
  var hasBorder = _ref.hasBorder;
  if (hasBorder) {
    return /*#__PURE__*/css(StyledModalFooterInner, "{border-top:", rem(1), " solid ", colors.coolGray_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:hasBorderStyles;"));
  }
  return /*#__PURE__*/css(StyledModalFooterInner, "{border-top:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:hasBorderStyles;"));
};
var isFlushPaddingStyles = function isFlushPaddingStyles(_ref2) {
  var isFlushPadding = _ref2.isFlushPadding;
  if (isFlushPadding) {
    return /*#__PURE__*/css("padding:0;&:first-of-type,&:nth-last-of-type(2){margin-right:", rem(0), ";}", StyledModalFooterInner, "{padding:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:isFlushPaddingStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledModalFooter = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1f24jrb0"
} : {
  target: "e1f24jrb0",
  label: "StyledModalFooter"
})(resetStyles, defaultStyles, hasBorderStyles, isFlushPaddingStyles, utilityStyles);
export default StyledModalFooter;